import { Terms } from '../api';

export const fetchTerms = () => (dispatch, getStore) => {
  Terms.get()
    .then((response) => dispatch(setTerms(response.data)))
    .catch((e) => console.log('ERROR', e));
};

export const setTerms = (terms) => ({
  type: 'SET_TERMS',
  terms,
});
